import { Colors } from "./Colors"

export const Classes = {
    Header: {
        display:'flex'
        ,flexDirection:'row'
        ,alignItems:'center'
        ,alignContent:'flex-start'
        ,width:"100%"
        ,flex:1
    }
    ,Box: {
        ColumnStart: {
            display:'flex'
            ,flexDirection: 'column'
            ,alignContent:'center'
            ,alignItems:'flex-start'
        }
        ,
        ColumnCenter: {
            display:'flex'
            ,flexDirection: 'column'
            ,alignContent:'center'
            ,alignItems:'center'
        }
        ,
        RowStart: {
            display:'flex'
            ,flexDirection: 'row'
            ,alignContent:'flex-start'
            ,alignItems:'center'
        }
        ,  RowEnd: {
            display:'flex'
            ,flexDirection: 'row'
            ,alignContent:'flex-end'
            ,alignItems:'center'
        }
        , RowCenter: {
            display:'flex'
            ,flexDirection: 'row'
            ,alignContent:'center'
            ,alignItems:'center'
        }
        , RowSpaceBetween: {
            display:'flex'
            ,flexDirection: 'row'
            ,alignContent:'space-between'
            ,alignItems:'space-between'
        }
        
    }
    ,Card: {
        LeftBorderedCard:{
            padding: "10px"
            , display: "flex"
            , margin: "3px"
            , backgroundColor: Colors.primary100
            , borderColor: "white"
            , borderLeftWidth: "3px"
            , borderLeftStyle: "solid"
            ,backgroundColor: Colors.primary200
            
            //, boxShadow: "1px 2px 20px " + Colors.secondary100
            , flexDirection: 'column'
            , flex: 1
        }
        ,NoBorderedCard: {
            padding: "10px"
            , display: "flex"
            , margin: "10px"
            , backgroundColor: Colors.primary100
            , borderColor: Colors.primary100
            , borderWidth: 1
            //, boxShadow: "1px 2px 20px " + Colors.secondary100
            , flexDirection: 'column'
            , flex: 1
        }
        ,Subscription: {
            padding: "10px"
            , display: "flex"
            , margin: "10px"
            , backgroundColor: Colors.secondary200
            , borderColor: Colors.primary300
            , borderStyle:'solid'
            , borderWidth: 1
            ,borderRadius:10
            //, boxShadow: "1px 2px 20px " + Colors.secondary100
            , flex: 1
          
        }
    }
   
    
    , SubscriptionTile: {
        padding: 10
        , margin: 10
        , width: 100
        , backgroundColor: Colors.primary100
        , borderColor: Colors.primary200
        , boxShadow: '1px 2px 2px ' + Colors.primary200
    }
   
    , Input: {
        backgroundColor: Colors.primary300
        , padding: 3
        , borderRadius: 5
        , maxWidth: 300
        , margin: 10
        , flex: 1
    }
    , Text: {
        Normal: {
            fontSize: "14px",
            color:Colors.textPrimary
        },
        ValidationMessage: {
            fontSize: "13px",
            color: "red"
        },
        Subtitle: {
            fontSize: "10px"
            ,color:Colors.textPrimary
        },
        h1:{
            fontSize:'29px',
            fontWeight:"400",
            color:Colors.textPrimary,
            flex:1,
            margin:2,
        },
        h2:{
            fontSize:'25px',
            fontWeight:"300",
            color:Colors.textPrimary,
            flex:1,
            margin:2,
        },
        h3:{
            fontSize:'20px',
            fontWeight:"200",
            color:Colors.textPrimary,
            flex:1,
            margin:2,
        },
        h4:{
            fontSize:'18px',
            fontWeight:"200",
            color:Colors.textPrimary,
            flex:1,
            margin:2,
        },
        Alert: {
            fontSize: "10px",
            color: "red"
        }
    }
    , Body: {

    }
    , Container: {
        display: "flex"
       , flexDirection: 'column'
       ,float:"center"
       
    }
    , ContainerFluid: {
        display: "flex"
       , flexDirection: 'column'
    }
    , Button: {
        Primary:
        {
            padding: 10
            , margin: 10
            , display:"block"
            , backgroundColor: Colors.primary400
            , boxShadow: '1px 2px 2px ' + Colors.primary200
            , color: Colors.secondary400
            , borderRadius: 10
            , width: 200
            , textAlign: 'center'
            , textTransform:'capitalize'
            , fontWeight: 'bold'
            , cursor: 'pointer'
        }
        , Secondary:
        {
            padding: 10
            , margin: 10
            , display:"block"
            , backgroundColor: Colors.secondary200
            //, boxShadow: '1px 2px 2px ' + Colors.secondary400
            , color: "white"
            , borderRadius: 10
            , width: 200
            , textTransform:'capitalize'
            , textAlign: 'center'
            , fontWeight: 'bold'
            , cursor: 'pointer'
        }
        , Alert:
        {

        }

    }
}